import React from 'react';

const Card = ({ children, id = '', className = '', onClick = () => {} }) => {
  return (
    <div
      id={id}
      className={`w-full bg-white border rounded-lg flex flex-wrap p-6 flex-col gap-4 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
